// packages/shared-hooks/src/clients/useArchiveLegalEntityRequisites.ts
//
// `POST /clients/:id/legal-entities/:leId/requisites/:requisitesId/archive` —
// soft-deletes one bank set. INVARIANT: the backend refuses the LAST active
// set of a legal entity with 409 DOMAIN_CONFLICT, so callers must disable the
// control rather than rely on the round trip for the common case.
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { LegalEntityRequisitesSchema, type LegalEntityRequisites } from '@magimp/shared';
import { useApiClient } from '../api/context.js';
import { clientsKeys } from './keys.js';

export function useArchiveLegalEntityRequisites(
  clientId: string,
  legalEntityId: string,
  requisitesId: string,
) {
  const client = useApiClient();
  const qc = useQueryClient();
  return useMutation<LegalEntityRequisites, unknown, void>({
    mutationFn: () =>
      client.post<LegalEntityRequisites>(
        `/clients/${clientId}/legal-entities/${legalEntityId}/requisites/${requisitesId}/archive`,
        undefined,
        {},
        LegalEntityRequisitesSchema,
      ),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: clientsKeys.detail(clientId) });
      void qc.invalidateQueries({ queryKey: clientsKeys.all });
    },
  });
}
